<template>
  <div class="ourHistory">
    <BreadsCrums page="ourHistory" previous="home" />
    <section class="portfolio-detail garden-set-pd-sm-lg">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-sm-12">
            <div class="box-content">
              <div class="title">
                <h3>
                  <i>{{ $t("navBar.ourHistory") }}</i>
                </h3>
              </div>
              <div class="question">
                <p>{{ $t("ourHistoryText") }}</p>
                <div class="holder-question">
                  <div class="panel-group" id="accordion">
                    <div class="panel panel-default">
                      <div class="panel-heading">
                        <h4 class="panel-title">
                          <a
                            data-toggle="collapse"
                            data-parent="#accordion"
                            href="#collapse1"
                            class="btn btn-info btn-block"
                            >{{ $t("2010") }}</a
                          >
                        </h4>
                      </div>
                      <div id="collapse1" class="panel-collapse collapse">
                        <div class="panel-body">{{ $t("2010Text") }}</div>
                      </div>
                    </div>
                    <div class="panel panel-default">
                      <div class="panel-heading">
                        <h4 class="panel-title">
                          <a
                            data-toggle="collapse"
                            data-parent="#accordion"
                            href="#collapse2"
                            class="btn btn-info btn-block"
                            >{{ $t("feb2011") }}</a
                          >
                        </h4>
                      </div>
                      <div id="collapse2" class="panel-collapse collapse">
                        <div class="panel-body">{{ $t("feb2011Text") }}</div>
                      </div>
                    </div>
                    <div class="panel panel-default">
                      <div class="panel-heading">
                        <h4 class="panel-title">
                          <a
                            data-toggle="collapse"
                            data-parent="#accordion"
                            href="#collapse3"
                            class="btn btn-info btn-block"
                            >{{ $t("ap2011") }}</a
                          >
                        </h4>
                      </div>
                      <div id="collapse3" class="panel-collapse collapse">
                        <div class="panel-body">{{ $t("ap2011Text") }}</div>
                      </div>
                    </div>
                    <div class="panel panel-default">
                      <div class="panel-heading">
                        <h4 class="panel-title">
                          <a
                            data-toggle="collapse"
                            data-parent="#accordion"
                            href="#collapse4"
                            class="btn btn-info btn-block"
                            >{{ $t("sept2011") }}</a
                          >
                        </h4>
                      </div>
                      <div id="collapse4" class="panel-collapse collapse">
                        <div class="panel-body">{{ $t("sept2011Text") }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  mounted() {
    Vue.nextTick(function() {
      // console.log("re-render");
    });
  },
  created() {
    document.title = this.$i18n.t("navBar.ourHistory");
  },
  name: "OurHistory"
};
</script>

<style scoped>
.btn-block {
  display: block !important;
  width: 100% !important;
}
.btn-info {
  color: #fff !important;
  background-color: #5bbb2d !important;
  border-color: #5bbb2d !important;
}
.btn {
  display: inline-block !important;
  font-weight: 400 !important;
  text-align: center !important;
  vertical-align: middle;
  border: 1px solid transparent !important;
  padding: 0.375rem 0.75rem !important;
  font-size: 1rem !important;
  line-height: 1.5 !important;
  border-radius: 0.25rem !important;
  transition: color 0.15s ease-in-out;
  background-color: 0.15s ease-in-out !important;
  border-color: 0.15s ease-in-out;
  box-shadow: 0.15s ease-in-out;
}
.panel-heading {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
.panel-body {
  flex: 1 1 auto;
  padding: 1.25rem;
}
.title h3 i {
  text-transform: capitalize;
  font-weight: bolder !important;
}
</style>
